export default __webpack_public_path__ + "static/media/add-icon.f1a1cb88.svg";